import React, { useState, useEffect } from "react";
import AdminServices from "../../services/AdminServices";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
 import Swal from "sweetalert2";
import loginpage from '../../component/Header/img/loginpage.png'
function Login({ setIsAuthenticated ,setRole }) {
  const navigate = useNavigate();
  const [loginMode, setLoginMode] = useState("email");
  const [mobileOrEmail, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [adminId, setAdminId] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpPassword, setOtpPassword] = useState("");
  const [rememberPassword, setRememberPassword] = useState(false);
  const [error, setError] = useState("");

useEffect(() => {
  if (loginMode === "email") {
    const rememberedEmail = Cookies.get('rememberEmail');
    // const rememberedPassword = Cookies.get('rememberPassword');
 
    if (rememberedEmail) setEmail(rememberedEmail);
    // if (rememberedPassword) setPassword(rememberedPassword);
  }
}, [loginMode]);



   const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = await AdminServices.login({ mobileOrEmail, password });
 
      if (data.status === true) {       
        localStorage.setItem('authToken', data?.token);
        localStorage.setItem('userRole', data?.data?.role);
        localStorage.setItem('name', data?.data?.name);
        localStorage.setItem('image', data?.data?.image);
        const permissionsData = await AdminServices.getPermissions(data?.data?.role);
        const permissions = {};
        permissionsData.data.forEach((item) => {
          permissions[item.menuItem] = item.roles[data?.data?.role];
        });
        localStorage.setItem('userPermissions', JSON.stringify(permissions));
       // const rememberPassword = document.getElementById('flexCheckChecked').checked;
      // if (rememberPassword) {
      //   Cookies.set('rememberEmail', mobileOrEmail, { expires: 7 });
      //   Cookies.set('rememberPassword', password, { expires: 7 }); // Avoid storing plaintext passwords
      // } else {
      //   Cookies.remove('rememberEmail');
      //   Cookies.remove('rememberPassword');
      // }
  
  Swal.fire({
        icon: "success",
        title: "Login Successful 🎉",
        text: data?.message,
        timer: 1500,
        showConfirmButton: false
      });
        setIsAuthenticated(true);
            setRole(data?.data?.role);
          // navigate("/dashboard");
        window.location.reload();
      } else {
        // setError('*Invalid Credentials');
         Swal.fire({
        icon: "error",
        title: "Login Failed ",
       text: data?.error
      });
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(`*${err.response.data.message}`);
      } else {
        setError('*Something went wrong. Please try again.');
      }
    }
  };
 
  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      const res = await AdminServices.loginSendOtp({
        mobileOrEmail: mobile,
        password:otpPassword,
      });
      if (res.status === true) {
        setAdminId(res.adminId);
        setOtpSent(true);
        setError("");
Swal.fire({
  icon: "success",
  text: res?.message,
  timer: 1500,         
  showConfirmButton: false, 
});

        const remember = document.getElementById("remember").checked;
        if (remember) {
          Cookies.set("rememberMobile", mobile, { expires: 7 });
     Cookies.set("rememberPassword", otpPassword, { expires: 7 });
        } else {
          Cookies.remove("rememberMobile");
          Cookies.remove("rememberPassword");
        }
      } 
      
      // else {
      //   setError("*Invalid Credentials");
      // }
          else {
      Swal.fire({
        icon: "error",
        // title: "Login Failed",
        text: res?.message,
      });
    }
    } catch (err) {
   Swal.fire({
  icon: "error",
  text:
    err?.response?.data?.message || 
    err?.message ||                
    "Something went wrong",         
});
      // setError(err?.response?.data?.message || "*Something went wrong");
    }
  };
 const handleVerifyOtp = async (e) => {
  e.preventDefault();
  try {
    const data = await AdminServices.loginVerifyOtp({
      adminId,
      // otpCode: otp,
      otpCode: Number(otp)
    });
    if (data.status === true) {
      localStorage.setItem("authToken", data?.token);
      localStorage.setItem("userRole", data?.data?.role);
      localStorage.setItem("name", data?.data?.name);
      localStorage.setItem("image", data?.data?.image);
      try {
        const permissionsData = await AdminServices.getPermissions(
          data?.data?.role
        );
        const permissions = {};
        permissionsData.data.forEach((item) => {
          permissions[item.menuItem] =
            item.roles[data?.data?.role];
        });
        localStorage.setItem("userPermissions", JSON.stringify(permissions));
      } catch (err) {
        console.log("Permission API failed", err);
        localStorage.setItem("userPermissions", JSON.stringify({}));
      }
   Swal.fire({
        icon: "success",
        title: "Login Successful 🎉",
        text: data?.message || "OTP Verified Successfully",
        // timer: 1500,
        showConfirmButton: false,
      });
      setIsAuthenticated(true);
     window.location.reload();
    // } else {
    //   setError("*Invalid OTP");
    // }

 } else {
      Swal.fire({
        icon: "error",
        title: "Error ❌",
        text: data?.message,
      });
    }
  } catch (err) {
    // setError(err?.response?.data?.message || "*OTP verification failed");
     Swal.fire({
      icon: "error",
      // title: "Failed",
      text:
        err?.response?.data?.message ||
        "OTP verification failed",
    });
  }
};
const handleMobileChange = (e) => {
  let value = e.target.value;
  value = value.replace(/\D/g, "");
  if (value.length > 10) {
    value = value.slice(0, 10);
  }
 
  setMobile(value);
};
const switchMode = (mode) => {
  setLoginMode(mode);
  setError("");
  setMobile("");
  setPassword("");
  setOtp("");
  setAdminId("");
  setOtpSent(false);
  setEmail("");
  if (mode === "otp") {
    setPassword("");
  }
};
 
  return (
    <div className="login-section">
      <div className="login-section-inner">
        <div className="row">
          <div className="col-md-6 pe-0">
            <div className="login-section-left">
              <p>Welcome to Admin Panel</p>
 
              <form className="user-login" >
 
                {loginMode === "email" && (
                  <>
                    <div className="d-flex justify-content-center gap-2 mb-3">
                      <div
                        className="otp_btn cursor-pointer"
                        onClick={() => switchMode("otp")}
                      >
                        Login with OTP
                      </div>
                    </div>
                    <div className="sign-in-seperator">
                      <span>or Sign in with Email</span>
                    </div>
 
                    <div className="input-field mb-3">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={mobileOrEmail}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <div className="input-field mb-3">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />
                    </div>
 
               
                  <div className="input-field mb-3">
                  <input
                    onClick={handleSubmit}
                    type="submit"
                    className="form-control"
                    id="login-btn"
                    value="Login"
                  />
                </div>
                  </>
                )}
 
                {loginMode === "otp" && (
                  <>
                    <div className="d-flex justify-content-center gap-2 mb-3">
                      <div
                        className="otp_btn cursor-pointer"
                        onClick={() => switchMode("email")}
                      >
                        Login with Email
                      </div>
                    </div>
 
                    <div className="input-field mb-3">
                      <label>Mobile</label>
                      <input
                        type="text"
                        className="form-control"
                        value={mobile}
                         onChange={handleMobileChange}
                      />
                    </div>
 
                    <div className="input-field mb-3">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control"
                     value={otpPassword}
                      onChange={(e) => setOtpPassword(e.target.value)}
                      />
                    </div>
                    <div className="form-check mb-3">
  <input
    type="checkbox"
    className="form-check-input"
    id="remember"
    checked={rememberPassword}
    onChange={(e) => setRememberPassword(e.target.checked)}
  />
  <label className="form-check-label" htmlFor="remember">
    Remember Me
  </label>
</div>
                    {otpSent && (
                      <div className="input-field mb-3">
                        <label>OTP</label>
                        <input
                          type="text"
                          className="form-control"
                          value={otp}
                          onChange={(e) =>
                            setOtp(e.target.value.replace(/\D/g, ""))
                          }
                        />
                      </div>
                    )}
                    <button
                      type="button"
                      className="form-control login_btn"
                      onClick={otpSent ? handleVerifyOtp : handleSendOtp}
                    >
                      {otpSent ? "Verify OTP" : "Send OTP"}
                    </button>
                  </>
                )}
 
              </form>
            </div>
          </div>
 
          {/* RIGHT SIDE */}
          <div className="col-md-6 ps-0">
            <div className="login-section-right">
              <div className="login_logo">
                <img src="img/PaarLogo.png" alt="Logo" />
              </div>
              <div className="light-field px-4">
                <img src={loginpage} alt="loginpage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default Login;



// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import AdminServices from '../../services/AdminServices';
// import Cookies from 'js-cookie';

// function Login({ setIsAuthenticated, setRole }) {
//   const [mobileOrEmail, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const navigate = useNavigate();
//   useEffect(() => {
//     const rememberedEmail = Cookies.get('rememberEmail');
//     const rememberedPassword = Cookies.get('rememberPassword');

//     if (rememberedEmail) setEmail(rememberedEmail);
//     if (rememberedPassword) setPassword(rememberedPassword);
//   }, []);

 
  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const data = await AdminServices.login({ mobileOrEmail, password });
  
//       if (data.status === true) {
        
//         localStorage.setItem('authToken', data?.token);
//         localStorage.setItem('userRole', data?.data?.role);
//         localStorage.setItem('name', data?.data?.name);
//         localStorage.setItem('image', data?.data?.image);
  
       
//         const permissionsData = await AdminServices.getPermissions(data?.data?.role);
//         const permissions = {};
//         permissionsData.data.forEach((item) => {
//           permissions[item.menuItem] = item.roles[data?.data?.role];
//         });
//         localStorage.setItem('userPermissions', JSON.stringify(permissions));

        
//       const rememberPassword = document.getElementById('flexCheckChecked').checked;
//       if (rememberPassword) {
//         Cookies.set('rememberEmail', mobileOrEmail, { expires: 7 });
//         Cookies.set('rememberPassword', password, { expires: 7 }); // Avoid storing plaintext passwords
//       } else {
//         Cookies.remove('rememberEmail');
//         Cookies.remove('rememberPassword');
//       }

  
//         setIsAuthenticated(true);
//         window.location.reload();
//       } else {
//         setError('*Invalid Credentials');
//       }
//     } catch (err) {
//       // Check if the error response exists
//       if (err.response && err.response.data && err.response.data.message) {
//         setError(`*${err.response.data.message}`);
//       } else {
//         setError('*Something went wrong. Please try again.');
//       }
//     }
//   };
  
//   return (
//     <div className="login-section">
//       <div className="login-section-inner">
//         <div className="row">
//           <div className="col-md-6 pe-0">
//             <div className="login-section-left">
//               <h1>Login</h1>
//               <p>Welcome to the Admin Panel!</p>
//               <form className="user-login" >
//                 <div className="input-field mb-3">
//                   <label htmlFor="userEmail" className="form-label">Email</label>
//                   <input
//                     type="email"
//                     className="form-control"
//                     id="userEmail"
//                     placeholder="example@example.com"
//                     value={mobileOrEmail}
//                     onChange={(e) => setEmail(e.target.value)}
//                   />

//                 </div>
//                 <div className="input-field mb-3">
//                   <label htmlFor="password" className="form-label">Password</label>
//                   <input
//                     type="password"
//                     className="form-control"
//                     id="password"
//                     placeholder="••••••••••"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                   />
//                 </div>
//                 <div className="form-check d-flex align-items-center gap-2">
//                   <input
//                     className="form-check-input"
//                     type="checkbox"
//                     defaultValue=""
//                     id="flexCheckChecked"
//                     defaultChecked=""
//                   />
//                   <label className="form-check-label" htmlFor="flexCheckChecked">
//                     Remember me
//                   </label>
//                 </div>
//                    {/* Error Message Section */}
//                    {error && (
//                   <div style={{ color: 'red', marginBottom: '10px', fontSize: '14px' }}>
//                     {error}
//                   </div>
//                 )}
//                 <div className="input-field mb-3">
//                   <input
//                     onClick={handleSubmit}
//                     type="submit"
//                     className="form-control"
//                     id="login-btn"
//                     value="Login"
//                   />
//                 </div>
//               </form>
//               {/* <p>© 2024 Pashuchikitsa Made by <a href="https://truevalueinfosoft.com/">True Value Infosoft</a>.</p> */}
//             </div>
//           </div>
//           <div className="col-md-6 ps-0">
//             <div className="login-section-right">
//               <div className="logo-field">
//                 <img src="img/PaarLogo.png" alt="Logo"  />
//               </div>
//               <div className="light-field px-4">
//                 <img src="img/cuate.svg" alt="Illustration" />
//               </div>
//             </div>
//           </div>
//         </div>
//         <p className="company-details">
//           © 2025–2026 Paar Digital Services. All rights reserved.
//         </p>
//       </div>
//     </div>
//   );
// }

// export default Login;
